export class UpdateClientOrganizationRequest {
  assignedSeats: number;
  name: string;
}
